import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Home, Phone, ArrowRight } from 'lucide-react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function NotFoundPage() {
  useEffect(() => {
    document.title = '404 Page Not Found | Evolution Electric';
    // Tell search engines not to index this page
    let noindex = document.querySelector('meta[name="robots"]');
    if (!noindex) {
      noindex = document.createElement('meta');
      noindex.setAttribute('name', 'robots');
      document.head.appendChild(noindex);
    }
    noindex.setAttribute('content', 'noindex, nofollow');

    // Remove canonical so Google doesn't associate this with homepage
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.remove();

    return () => {
      const tag = document.querySelector('meta[name="robots"][content="noindex, nofollow"]');
      if (tag) tag.remove();
    };
  }, []);

  return (
    <div data-testid="not-found-page">
      <Navbar />
      <main className="min-h-screen flex items-center justify-center px-6 pt-20 bg-white">
        <div className="text-center max-w-lg">
          <p className="font-display text-[10rem] leading-none text-zinc-100 select-none">404</p>
          <h1 className="font-heading text-3xl sm:text-4xl font-black uppercase tracking-tight -mt-12 mb-4" data-testid="404-title">
            Page Not Found
          </h1>
          <p className="font-body text-sm text-zinc-500 leading-relaxed mb-8">
            The page you're looking for doesn't exist or has been moved. Let us help you find what you need.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to="/" className="inline-flex items-center gap-2 bg-yellow-400 text-black font-heading font-bold text-sm uppercase tracking-wider px-6 py-3 border border-black hover:-translate-y-0.5 transition-transform" data-testid="404-home-btn">
              <Home className="w-4 h-4" /> Back to Home
            </Link>
            <a href="/#contact" className="inline-flex items-center gap-2 bg-black text-white font-heading font-bold text-sm uppercase tracking-wider px-6 py-3 border border-black hover:-translate-y-0.5 transition-transform" data-testid="404-contact-btn">
              Get a Quote <ArrowRight className="w-4 h-4" />
            </a>
            <a href="tel:+16159615930" className="inline-flex items-center gap-2 bg-transparent text-black font-heading font-bold text-sm uppercase tracking-wider px-6 py-3 border border-black hover:-translate-y-0.5 transition-transform" data-testid="404-phone-btn">
              <Phone className="w-4 h-4" /> Call Us
            </a>
          </div>
          <div className="mt-12 text-left border border-black p-6 bg-zinc-50">
            <h2 className="font-heading text-sm font-bold uppercase tracking-tight mb-3">Popular Pages</h2>
            <ul className="space-y-2">
              <li><Link to="/services/residential-electrical-services-nashville" className="font-body text-sm text-zinc-600 hover:text-yellow-600 transition-colors" data-testid="404-link-residential">Residential Electrical Services</Link></li>
              <li><Link to="/services/commercial-electrical-services-nashville" className="font-body text-sm text-zinc-600 hover:text-yellow-600 transition-colors" data-testid="404-link-commercial">Commercial Electrical Services</Link></li>
              <li><Link to="/blog/electrical-panel-upgrade-cost-nashville" className="font-body text-sm text-zinc-600 hover:text-yellow-600 transition-colors" data-testid="404-link-blog">Electrical Panel Upgrade Cost Guide</Link></li>
              <li><Link to="/blog/ev-charger-installation-guide-nashville" className="font-body text-sm text-zinc-600 hover:text-yellow-600 transition-colors" data-testid="404-link-ev">EV Charger Installation Guide</Link></li>
            </ul>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
